<template>
  <v-card>
    <v-container fluid grid-list-md>
      <v-flex xs10 offset-xs1>
        <v-card-title primary-title class="justify-center">
          <div>
            <div class="display-1 font-weight-medium blue--text">Drivers Certificate</div>
            <center>
              <span class="subheading grey--text">Create</span>
            </center>
          </div>
        </v-card-title>
      </v-flex>
    </v-container>
    
    <v-container fluid grid-list-md>
      <v-flex xs10 offset-xs1>
        <v-expansion-panel 
        focusable
        >
          <v-expansion-panel-content>
            <div slot="header" class="title">Personal Details</div>
            <v-card flat>
              <v-card-text>
                <v-form>
                  <v-checkbox
                    v-model="existingRecord"
                    label="Existing Record from myOffspring"
                    color="info"
                    value="Existing Record"
                    hide-details
                  ></v-checkbox>
                  <br>
                  <v-text-field
                    label="Hash ID"
                    background-color="blue lighten-5"
                    append-icon="search"
                    v-model.trim="hashID"
                    :disabled="!existingRecord"
                    @click:append=""
                    outline
                  ></v-text-field>
                 <v-text-field
                  label="Full Name"
                  v-model.trim="fullName"
                  background-color="blue lighten-5"
                  :disabled="existingRecord"
                  required
                  outline
                  ></v-text-field>
                  <v-text-field
                  label="Mother's Full Name"
                  v-model.trim="motherFullName"
                  background-color="blue lighten-5"
                  :disabled="existingRecord"
                  outline
                  ></v-text-field>
                  <v-text-field
                  label="Father's Full Name"
                  v-model.trim="fatherFullName"
                  background-color="blue lighten-5"
                  :disabled="existingRecord"
                  outline
                  ></v-text-field>
                  <v-layout>
                    <v-flex xs6>
                      <v-menu
                      ref="dateOfBirth_menu"
                      :close-on-content-click="false"
                      v-model="dateOfBirth_menu"
                      :disabled="existingRecord"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      >
                        <v-text-field
                        slot="activator"
                        v-model="dateOfBirth"
                        label="Date of Birth"
                        prepend-icon="event"
                        background-color="blue lighten-5"
                        :disabled="existingRecord"
                        readonly
                        outline
                        ></v-text-field>
                        <v-date-picker
                        ref="picker"
                        v-model="dateOfBirth"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1900-01-01"
                        @change="dateOfBirth_save"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                      ref="timeOfBirth_menu"
                      :close-on-content-click="false"
                      v-model="timePicker"
                      :disabled="existingRecord"
                      :nudge-right="40"
                      :return-value.sync="timeOfBirth"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      >
                        <v-text-field
                        slot="activator"
                        v-model="timeOfBirth"
                        label="Time of Birth"
                        prepend-icon="access_time"
                        background-color="blue lighten-5"
                        :disabled="existingRecord"
                        readonly
                        outline
                        ></v-text-field>
                        <v-time-picker
                        v-if="timePicker"
                        v-model="timeOfBirth"
                        full-width
                        format="24hr"
                        @change="timeOfBirth_save"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-text-field
                  label="Place of Birth (Facility, City, State/Province, Country)"
                  v-model.trim="placeOfBirth"
                  outline
                  background-color="blue lighten-5"
                  :disabled="existingRecord"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header" class="title">Further Details</div>
            <v-card flat>
              <v-card-text>
                <v-form>
                  <v-combobox
                    v-model="gender"
                    :items="gender_items"
                    label="Gender"
                    outline
                    background-color="blue lighten-5"
                  ></v-combobox>
                  <v-text-field
                    label="Address"
                    background-color="blue lighten-5"
                    v-model.trim="address"
                    outline
                  ></v-text-field>
                  <v-text-field
                    label="Phone Number"
                    background-color="blue lighten-5"
                    v-model.trim="phoneNumber"
                    outline
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header" class="title">Certificate Info</div>
            <v-card flat>
              <v-card-text>
                <v-form>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu_date"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="date"
                      label="Date"
                      prepend-icon="event"
                      background-color="blue lighten-5"
                      outline
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" @input="menu_date = false"></v-date-picker>
                  </v-menu>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                        v-model="physicalMentalFit"
                        :items="['Yes','No']"
                        label="Physical and mentally fit to drive"
                        background-color="blue lighten-5"
                        outline
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="upperLimbsAmputated"
                        label="Upper Limbs Amputated"
                        color="info"
                        value="Upper Limbs Amputated"
                        hide-details
                        @change="upperLimbsLeftProsthesis = false; upperLimbsRightProsthesis = false;"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="upperLimbsLeftProsthesis"
                        label="Left Arm Prosthesis"
                        color="info"
                        value="Left Arm Prosthesis"
                        hide-details
                        :disabled="!upperLimbsAmputated || upperLimbsAmputated == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="upperLimbsRightProsthesis"
                        label="Right Arm Prosthesis"
                        color="info"
                        value="Right Arm Prosthesis"
                        hide-details
                        :disabled="!upperLimbsAmputated || upperLimbsAmputated == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="lowerLimbsAmputated"
                        label="Lower Limbs Amputated"
                        color="info"
                        value="Lowe Limbs Amputated"
                        hide-details
                        @change="lowerLimbsLeftProsthesis = false; lowerLimbsRightProsthesis = false;"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="lowerLimbsLeftProsthesis"
                        label="Left Leg Prosthesis"
                        color="info"
                        value="Left Leg Prosthesis"
                        hide-details
                        :disabled="!lowerLimbsAmputated || lowerLimbsAmputated == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        v-model="lowerLimbsRightProsthesis"
                        label="Right Leg Prosthesis"
                        color="info"
                        value="Right Leg Prosthesis"
                        hide-details
                        :disabled="!lowerLimbsAmputated || lowerLimbsAmputated == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="postPolio"
                        label="Post-poliomyelitis - One paralyzed leg"
                        color="info"
                        value="Post-poliomyelitis - One paralyzed leg"
                        hide-details
                        @change="postPolioLeftLeg = false; postPolioRightLeg = false;"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs3>
                      <v-checkbox
                        v-model="postPolioLeftLeg"
                        label="Left"
                        color="info"
                        value="Left"
                        :disabled="!postPolio || postPolio == null"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs3>
                      <v-checkbox
                        v-model="postPolioRightLeg"
                        label="Right"
                        color="info"
                        value="Right"
                        :disabled="!postPolio || postPolio == null"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="paraplegic"
                        label="Paraplegic - Paralyzed from the waist down"
                        color="info"
                        value="Paraplegic - Paralyzed from the waist down"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <br>
                  <br>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                        v-model="hasClearEyesight"
                        :items="['Yes','No']"
                        label="Has Clear Eye Sight"
                        background-color="blue lighten-5"
                        outline
                        @change="partiallyBlind = false; colorBlind = false; needsCorrectiveGlasses = false;"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3>
                      <v-checkbox
                        v-model="partiallyBlind"
                        label="Partially blind"
                        color="info"
                        value="Partially blind"
                        hide-details
                        :disabled="hasClearEyesight == 'Yes' || hasClearEyesight == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs3>
                      <v-checkbox
                        v-model="colorBlind"
                        label="Color blind"
                        color="info"
                        value="Color blind"
                        hide-details
                        :disabled="hasClearEyesight == 'Yes' || hasClearEyesight == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="needsCorrectiveGlasses"
                        label="Needs proper corrective glasses"
                        color="info"
                        value="Needs proper corrective glasses"
                        hide-details
                        :disabled="hasClearEyesight == 'Yes' || hasClearEyesight == null"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <br>
                  <br>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                        v-model="hasClearHearing"
                        :items="['Yes','No']"
                        label="Has Clear Hearing"
                        background-color="blue lighten-5"
                        outline
                        @change="speechHearingImpaired = false; needsHearingDevice = false;"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="speechHearingImpaired"
                        label="Speech / hearing impaired"
                        color="info"
                        value="Speech / hearing impaired"
                        hide-details
                        :disabled="hasClearHearing == 'Yes' || hasClearHearing == null"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox
                        v-model="needsHearingDevice"
                        label="Needs hearing device"
                        color="info"
                        value="Needs hearing device"
                        hide-details
                        :disabled="hasClearHearing == 'Yes' || hasClearHearing == null"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <br>
                  <br>
                  <v-layout>
                    <v-flex xs12>
                      <v-textarea
                        v-model="otherFindings"
                        auto-grow
                        label="Other findings (if necessary)"
                        background-color="blue lighten-5"
                        outline
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-dialog v-model="confirmSendDialog" persistent max-width="50%">
          <v-card>
            <v-card-title>
              <span class="headline">
              {{ $t('send_to_contract.confirm') }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <b>Please store the ID below in a safe place, as it is the unique ID for this Birth registration.</b>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field label="Hash ID" v-model="hashID" disabled></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn small class="mt-3" color="cyan" v-clipboard:copy="hashID" v-clipboard:success="onCopySucc" v-clipboard:error="onCopyError">
                      {{ $t('common.copy') }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Raw Tx" v-model="rawTx" multi-line disabled></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="blue--text darken-1" flat @click="confirmSend" v-show="canSend && !sending">{{ $t('common.confirm') }}</v-btn>
              <v-btn class="red--text darken-1" flat @click.native="confirmSendDialog = false" :v-show="!sending">{{ $t('common.cancel') }}</v-btn>
              <v-progress-circular indeterminate :size="50" v-show="sending" class="primary--text"></v-progress-circular>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs8 offset-xs2>
        <br>
        <p class="text-xs-center">
          <v-btn class="info" dark @click="">{{ $t('common.confirm') }}</v-btn>
        </p>
      </v-flex>
    </v-container>
  </v-card>
</template>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'

  import sha256 from 'js-sha256'

  import qrcode from 'qrcode'

  export default {
    data () {
      return {
        date: new Date().toISOString().substr(0, 10),
        menu_date: false,
        gender: '',
        gender_items: ['Male','Female','Other'],
        address: '',
        phoneNumber: '',
        physicalMentalFit: null,
        upperLimbsAmputated: null,
        upperLimbsLeftProsthesis: null,
        upperLimbsRightProsthesis: null,
        lowerLimbsAmputated: null,
        lowerLimbsLeftProsthesis: null,
        lowerLimbsRightProsthesis: null,
        postPolio: null,
        postPolioLeftLeg: null,
        postPolioRightLeg: null,
        paraplegic: null,
        hasClearEyesight: null,
        partiallyBlind: null,
        colorBlind: null,
        needsCorrectiveGlasses: null,
        hasClearHearing: null,
        speechHearingImpaired: null,
        needsHearingDevice: null,
        otherFindings: null,
        contractAddress: '31346cbb09a178da67afda6b43e503faae1bbcfa',
        abi: '',
        parsedAbi: null,
        method: null,
        existingRecord: false,
        inputParams: [],
        fullName: '',
        motherFullName: '',
        fatherFullName: '',
        dateOfBirth: '',
        dateOfBirth_menu: false,
        timeOfBirth: null,
        timeOfBirth_menu: false,
        timePicker: false,
        placeOfBirth: '',
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        execResultDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,
        hashID: '',
        searchHashID: '',
        resultStatus: '',
        resultFullName: 'loading...',
        resultMotherFullName: 'loading...',
        resultFatherFullName: 'loading...',
        resultDateOfBirth: 'loading...',
        resultTimeOfBirth: 'loading...',
        resultPlaceOfBirth: 'loading...',
        qr: ''
      }
    },
    computed: {
      notValid: function() {
        //@todo valid the address
        const nameCheck = /^(?!\s*$).+/.test(this.fullName)
        const dateOfBirthCheck = /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/.test(this.dateOfBirth.split("-").reverse().join("-")) && parseInt(this.dateOfBirth.replace(/-/g,"")) <= parseInt(this.todayFormattedDate())
        const timeOfBirthCheck = this.timeOfBirth == '' || /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.timeOfBirth)
        const gasPriceCheck = /^\d+\.?\d*$/.test(this.gasPrice) && this.gasPrice > 0
        const gasLimitCheck = /^\d+\.?\d*$/.test(this.gasLimit) && this.gasLimit > 0
        const feeCheck = /^\d+\.?\d*$/.test(this.fee) && this.fee > 0.0001
        return !(nameCheck && dateOfBirthCheck && timeOfBirthCheck && gasPriceCheck && gasLimitCheck && feeCheck)
      }
    },
    watch: {
      method: function() {
        this.inputParams = []
      },
      dateOfBirth_menu (val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    methods: {
      async send() {
        try {
          const abiJson = [{"constant": true, "inputs": [{"name": "hash", "type": "string"} ], "name": "getHeir", "outputs": [{"name": "result", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "hash", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "name": "newHeir", "outputs": [{"name": "result", "type": "string"} ], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"payable": true, "stateMutability": "payable", "type": "fallback"}, {"anonymous": false, "inputs": [{"indexed": false, "name": "hash", "type": "string"} ], "name": "heirEvent", "type": "event"} ]
          var newDateOfBirth = this.dateOfBirth.replace(/-/g,"")
          var newTimeOfBirth = this.timeOfBirth.replace(/:/g,"")
          this.hashID = sha256(this.fullName+this.motherFullName+this.fatherFullName+newDateOfBirth+newTimeOfBirth+this.placeOfBirth+Date.now())
          const encodedData = abi.encodeMethod(abiJson[1], [this.hashID, this.fullName, this.motherFullName, this.fatherFullName, newDateOfBirth, newTimeOfBirth, this.placeOfBirth]).substr(2)
          this.confirmSendDialog = true
          try {
            this.rawTx = await webWallet.getWallet().generateSendToContractTx(this.contractAddress, encodedData, this.gasLimit, this.gasPrice, this.fee)
          } catch (e) {
            this.$root.log.error('send_to_generate_tx_error', e.stack || e.toString() || e)
            alert(e.message || e)
            this.confirmSendDialog = false
            return false
          }
          this.canSend = true
        } catch (e) {
          this.$root.error('Params error')
          this.$root.log.error('send_to_contract_encode_abi_error', e.stack || e.toString() || e)
          this.confirmSendDialog = false
          return false
        }
      },

      async confirmSend() {
        this.sending = true
        try {
          const txId = await webWallet.getWallet().sendRawTx(this.rawTx)
          this.confirmSendDialog = false
          this.sending = false
          const txViewUrl = server.currentNode().getTxExplorerUrl(txId)
          this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0)
          this.$emit('send')

          this.fullName = ''
          this.motherFullName = ''
          this.fatherFullName = ''
          this.dateOfBirth = ''
          this.timeOfBirth = ''
          this.placeOfBirth = ''
        } catch (e) {
          alert(e.message || e)
          this.$root.log.error('send_to_contract_post_raw_tx_error', e.response || e.stack || e.toString() || e)
          this.confirmSendDialog = false
        }
      },

      async callTo() {
        if(this.searchHashID != ''){
          try {
            const abiJson = [{"constant": true, "inputs": [{"name": "hash", "type": "string"} ], "name": "getHeir", "outputs": [{"name": "result", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "hash", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "name": "newHeir", "outputs": [{"name": "result", "type": "string"} ], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"payable": true, "stateMutability": "payable", "type": "fallback"}, {"anonymous": false, "inputs": [{"indexed": false, "name": "hash", "type": "string"} ], "name": "heirEvent", "type": "event"} ]
            const encodedData = abi.encodeMethod(abiJson[0], [this.searchHashID]).substr(2)
            try {
              var encodedResult = await webWallet.getWallet().callContract(this.contractAddress, encodedData)
              encodedResult = '0x' + encodedResult
              var decodedResult = abi.decodeMethod(abiJson[0], encodedResult)
              var rawDoB = decodedResult[4].toString()
              var formattedDateOfBirth = ''
              if(rawDoB != '0'){
                formattedDateOfBirth = rawDoB.substring(0,4)+"-"+rawDoB.substring(4,6)+"-"+rawDoB.substring(6)
              }
              var rawToB = decodedResult[5].toString()
              var formattedTimeOfBirth = ''
              if(rawToB != '0'){
                switch(rawToB.length) {
                  case 3:
                    rawToB = '0' + rawToB
                    break;
                  case 2:
                    rawToB = '00' + rawToB
                    break;
                  case 1:
                    rawToB = '000' + rawToB
                    break;
                }
                formattedTimeOfBirth = rawToB.substring(0,2)+":"+rawToB.substring(2)
              }
              else{
                formattedTimeOfBirth = '00:00'
              }
              this.resultStatus = decodedResult[0]
              if(this.resultStatus == 'Heir record found.'){
                this.execResultDialog = true
                this.resultFullName = decodedResult[1]
                this.resultMotherFullName = decodedResult[2]
                this.resultFatherFullName = decodedResult[3]
                this.resultDateOfBirth = formattedDateOfBirth
                this.resultTimeOfBirth = formattedTimeOfBirth
                this.resultPlaceOfBirth = decodedResult[6]
                this.drawQrCode()
              }
              else{
                alert('Record not found!')
              }
            } catch (e) {
              this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e)
              alert(e.message || e)
              this.execResultDialog = false
            }
          } catch (e) {
            this.$root.error('Params error')
            this.$root.log.error('call_contract_encode_abi_error', e.stack || e.toString() || e)
            return false
          }
        }
      },
      dateOfBirth_save (date) {
        this.$refs.dateOfBirth_menu.save(this.dateOfBirth)
      },
      timeOfBirth_save () {
        this.$refs.timeOfBirth_menu.save(this.timeOfBirth)
      },

      todayFormattedDate() {
        var today = new Date();

        var dd = today.getDate().toString();
        var mm = (today.getMonth()+1).toString(); //January is 0!
        var yyyy = today.getFullYear().toString();

        if(dd<10){
          dd='0'+dd;
        } 

        if(mm<10){
          mm='0'+mm;
        } 

        var formattedDate = yyyy+mm+dd;

        return formattedDate;
      },

      onCopySucc: function() {
        this.$root.success('copy success')
      },
      onCopyError: function() {
        this.$root.error('copy fail')
      },

      drawQrCode() {
        qrcode.toDataURL(`${this.searchHashID}`, (err, url) => {
          this.qr = url
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/controllers/Certdrivers-Create.vue